import PropTypes from 'prop-types';
import React, { Component } from 'react';
import eventUtils from '../utils/event';
import { localize } from '../i18n';

const getScrollPercent = function getScrollPercent() {
  const h = document.documentElement;
  const b = document.body;
  const st = 'scrollTop';
  const sh = 'scrollHeight';
  let scroll = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight);
  let pageFull = true;
  if (isNaN(scroll) === true) {
    scroll = 0;
    pageFull = false;
  }
  return {
    percent: scroll * 100,
    pageFull,
  };
};

class LoadMore extends Component {
  constructor(props) {
    super(props);
    if (this.props.scrollBased === true) {
      this.eventListener = eventUtils.eventThrottler(() => {
        this.setScrollPercentage();
      });
    }
  }

  componentWillMount() {
    if (this.props.scrollBased === true) {
      eventUtils.addPassiveEventListener(window, 'scroll', this.eventListener);
    }
  }

  componentDidMount() {
    if (this.props.fillPage === true) {
      this.loadMoreToFillPage();
    }
  }

  // componentWillReceiveProps(nextProps) {
  //   console.log(nextProps);
  //   // if (this.props.fillPage === true) {
  //   //   this.loadMoreToFillPage();
  //   // }
  // }

  componentWillUnmount() {
    if (this.props.scrollBased === true) {
      window.removeEventListener('scroll', this.eventListener);
    }
  }

  setScrollPercentage() {
    const percentInfo = getScrollPercent();
    this.props.onChangeScroll(percentInfo.percent);
    if (this.props.scrollBased === true) {
      if (
        (this.props.maxThreshold !== null && percentInfo.percent >= this.props.maxThreshold)
        || (this.props.minThreshold !== null && percentInfo.percent <= this.props.minThreshold)
      ) {
        setTimeout(() => {
          this.props.onLoadMore();
        }, 10);
      }
    }
  }

  loadMoreToFillPage() {
    const percentInfo = getScrollPercent();
    if (percentInfo.pageFull === false) {
      this.props.onLoadMore();
    }
  }

  render() {
    const {
      scrollBased,
      onLoadMore,
    } = this.props;

    let loadMoreDisplay = null;

    if (scrollBased === false) {
      loadMoreDisplay = (
        <button
          type="button"
          className="md-btn md-btn-wave-light waves-effect waves-button waves-light md-btn-primary"
          onClick={(evt) => { onLoadMore(evt); }}
        >
          {this.props.t('Load More')}
        </button>
      );
    }

    return (
      <div className="uk-grid uk-grid-width-small-1-1 uk-text-center">
        <div>
          {loadMoreDisplay}
        </div>
      </div>
    );
  }
}

LoadMore.propTypes = {
  onChangeScroll: PropTypes.func,
  onLoadMore: PropTypes.func,
  scrollBased: PropTypes.bool,
  fillPage: PropTypes.bool,
  maxThreshold: PropTypes.number,
  minThreshold: PropTypes.number,
  t: PropTypes.func.isRequired,
};

LoadMore.defaultProps = {
  onChangeScroll: () => {},
  onLoadMore: () => {},
  scrollBased: false,
  fillPage: false,
  maxThreshold: 100,
  minThreshold: null,
};

export default localize(LoadMore);



// WEBPACK FOOTER //
// ./src/components/LoadMore.js